<template>
    <div class="grid">
        <Toast/>

        <!-- ========== Salud del módulo (reconciliación) ========== -->
        <div class="col-12" style="max-width: 1000px;" v-if="health">
            <div class="card">
                <h4>Salud del módulo
                    <Tag class="ml-2" :severity="health.clean ? 'success' : 'warning'"
                         :value="health.clean ? 'TODO CUADRA' : 'REVISAR'"/>
                </h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <h6 style="margin: 4px 0;">
                            <i :class="health.trialBalance.balanced ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                               :style="health.trialBalance.balanced ? 'color:#2e7d32;' : 'color:#c62828;'"></i>
                            Partida doble: Debe ${{ health.trialBalance.totalDebit }} / Haber ${{ health.trialBalance.totalCredit }}
                        </h6>
                        <h6 style="margin: 4px 0;">
                            <i :class="health.treasuryDiscrepancies.length === 0 ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                               :style="health.treasuryDiscrepancies.length === 0 ? 'color:#2e7d32;' : 'color:#c62828;'"></i>
                            Cuadre de tesorería: {{ health.treasuryDiscrepancies.length === 0 ? 'sin diferencias' : health.treasuryDiscrepancies.length + ' diferencia(s)' }}
                        </h6>
                    </div>
                    <div class="col-12 md:col-6">
                        <h6 style="margin: 4px 0;">
                            <i :class="coverageClean ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                               :style="coverageClean ? 'color:#2e7d32;' : 'color:#c62828;'"></i>
                            Cobertura: {{ coverageClean ? 'todos los documentos registrados' : (health.coverage.salesMissing.length + health.coverage.purchasesMissing.length + creditNotesMissing.length + stockAdjustmentsMissing.length) + ' documento(s) sin asiento' }}
                        </h6>
                        <h6 style="margin: 4px 0;">
                            <i class="pi pi-inbox" style="color:#777;"></i>
                            Cobros por clasificar: ${{ health.undepositedFunds }}
                        </h6>
                        <h6 v-if="health.inventory" style="margin: 4px 0;">
                            <i :class="health.inventory.matches ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                               :style="health.inventory.matches ? 'color:#2e7d32;' : 'color:#c62828;'"></i>
                            Inventario: {{ health.inventory.matches ? 'coincide con la bodega' : 'difiere en $' + health.inventory.difference }}
                        </h6>
                        <h6 v-if="health.customerCredits" style="margin: 4px 0;">
                            <i :class="health.customerCredits.matches ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                               :style="health.customerCredits.matches ? 'color:#2e7d32;' : 'color:#c62828;'"></i>
                            Saldos a favor: {{ health.customerCredits.matches ? 'coinciden con las notas de crédito sin canjear' : 'difieren en $' + health.customerCredits.difference }}
                        </h6>
                        <h6 v-if="health.fixedAssets" style="margin: 4px 0;">
                            <i :class="assetsClean ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                               :style="assetsClean ? 'color:#2e7d32;' : 'color:#c62828;'"></i>
                            Activos fijos: {{ assetsClean ? 'registrados y cuadrados' : 'el registro no cuadra con el mayor' }}
                        </h6>
                        <h6 v-if="health.missingBuiltins && health.missingBuiltins.length" style="margin: 4px 0;">
                            <i class="pi pi-times-circle" style="color:#c62828;"></i>
                            Faltan cuentas del sistema en tu plan ({{ health.missingBuiltins.length }})
                        </h6>
                        <h6 v-if="health.unprovisionedTreasury && health.unprovisionedTreasury.length" style="margin: 4px 0;">
                            <i class="pi pi-times-circle" style="color:#c62828;"></i>
                            Hay tesorería registrada en una cuenta general
                        </h6>
                    </div>
                </div>

                <Message v-if="health.inventory && !health.inventory.matches" severity="warn"
                         :closable="false" class="mt-2">
                    El inventario del mayor (${{ health.inventory.ledger }}) no coincide con el stock
                    valuado (${{ health.inventory.physical }}). Revise los
                    <router-link to="/dashboard/inventario/ajustes">ajustes de inventario</router-link>
                    marcados para revisar (stock previo negativo) y que no falte registrar una compra.
                </Message>

                <Message v-if="health.customerCredits && !health.customerCredits.matches" severity="warn"
                         :closable="false" class="mt-2">
                    Los saldos a favor de clientes del mayor (${{ health.customerCredits.ledger }}) no
                    coinciden con las notas de crédito vigentes sin canjear
                    (${{ health.customerCredits.documents }}). Falta o sobra el asiento de una nota,
                    de un canje o de una anulación.
                </Message>

                <Message v-if="health.fixedAssets && !assetsClean" severity="warn"
                         :closable="false" class="mt-2">
                    Tus activos registrados suman ${{ health.fixedAssets.registeredCost }} pero el mayor
                    dice ${{ health.fixedAssets.ledgerCost }}. Si declaraste activos en la apertura y no
                    los diste de alta, no se están depreciando.
                </Message>

                <DataTable v-if="health.treasuryDiscrepancies.length" :value="health.treasuryDiscrepancies" class="mt-2">
                    <Column field="finantialAccount" header="Cuenta de tesorería"></Column>
                    <Column field="account" header="Cuenta contable" style="width: 140px;"></Column>
                    <Column field="ledger" header="Según libros" style="width: 130px;"></Column>
                    <Column field="treasury" header="Según tesorería" style="width: 130px;"></Column>
                    <Column field="diff" header="Diferencia" style="width: 120px;"></Column>
                </DataTable>

                <Message v-if="!coverageClean" severity="warn" :closable="false" class="mt-2">
                    Ventas sin asiento: {{ health.coverage.salesMissing.join(', ') || '—' }} ·
                    Compras sin asiento: {{ health.coverage.purchasesMissing.join(', ') || '—' }} ·
                    Notas de crédito sin asiento: {{ creditNotesMissing.join(', ') || '—' }} ·
                    Ajustes de stock sin asiento: {{ stockAdjustmentsMissing.join(', ') || '—' }}
                </Message>
                <!-- Una cola de Celery perdida deja documentos y cobros sin asiento: se reponen
                     aquí (y cada noche por el beat). Idempotente (H47). -->
                <Button v-if="!coverageClean || health.treasuryDiscrepancies && health.treasuryDiscrepancies.length"
                        label="Generar asientos faltantes" icon="pi pi-refresh" class="p-button-outlined mt-2"
                        :loading="reposting" @click="repostMissing"/>
            </div>
        </div>

        <!-- ========== Balance de comprobación ========== -->
        <div class="col-12" style="max-width: 1000px;">
            <div class="card">
                <h4>Balance de Comprobación
                    <Tag v-if="mode" class="ml-2" :severity="mode === 'LIVE' ? 'success' : 'info'"
                         :value="mode === 'LIVE' ? 'OFICIAL' : 'VALIDACIÓN'"/>
                </h4>
                <div class="formgroup-inline">
                    <div class="field">
                        <label style="width: 90px;">Hasta la fecha</label>
                        <Calendar :showIcon="true" v-model="asOfDate" dateFormat="yy-mm-dd"/>
                    </div>
                    <Button label="Consultar" icon="pi pi-search" class="p-button-success mb-2"
                            :loading="loading" @click="loadTrialBalance"/>
                </div>
                <p class="tb-hint"><i class="pi pi-info-circle"></i> Suma lo cargado y lo abonado a cada cuenta hasta esa fecha, no su saldo neto. Haz clic en una cuenta para ver el detalle de los asientos que la componen.</p>
                <DataTable :value="rows" :loading="loading" :scrollable="true" scrollHeight="500px"
                           :rowHover="true" :rowClass="trialRowClass" @row-click="openLedger">
                    <Column field="code" header="Código" style="width: 130px;"></Column>
                    <Column field="name" header="Cuenta"></Column>
                    <Column header="Debe" style="width: 150px;" bodyClass="tb-num" headerClass="tb-num-h">
                        <template #body="slotProps">${{ money(slotProps.data.debit) }}</template>
                    </Column>
                    <Column header="Haber" style="width: 150px;" bodyClass="tb-num" headerClass="tb-num-h">
                        <template #body="slotProps">${{ money(slotProps.data.credit) }}</template>
                    </Column>
                </DataTable>

                <div class="tb-summary">
                    <div class="tb-summary-line">
                        <span class="tb-label">Total Debe</span>
                        <span class="tb-amount">${{ money(totalDebit) }}</span>
                    </div>
                    <div class="tb-summary-line">
                        <span class="tb-label">Total Haber</span>
                        <span class="tb-amount">${{ money(totalCredit) }}</span>
                    </div>
                    <Tag class="tb-summary-status"
                         :severity="balanced ? 'success' : 'danger'"
                         :icon="balanced ? 'pi pi-check' : 'pi pi-times'"
                         :value="balanced ? 'El balance cuadra' : 'El balance no cuadra'"/>
                </div>
            </div>
        </div>

        <!-- ========== Detalle de la cuenta (drill-down) ========== -->
        <Dialog v-model:visible="ledgerVisible" :modal="true" :dismissableMask="true"
                :style="{ width: '780px', maxWidth: '95vw' }" class="ledger-dialog">
            <template #header>
                <div class="ledger-header" v-if="ledger">
                    <span class="ledger-code">{{ ledger.code }}</span>
                    <span class="ledger-name">{{ ledger.name }}</span>
                </div>
            </template>

            <div v-if="ledgerLoading" class="ledger-loading">
                <i class="pi pi-spin pi-spinner"></i> Cargando movimientos…
            </div>

            <template v-else-if="ledger">
                <p class="ledger-desc">
                    Estos son los renglones de asiento que suman <b>${{ money(ledger.totalDebit) }}</b> al Debe y
                    <b>${{ money(ledger.totalCredit) }}</b> al Haber de esta cuenta en el balance de comprobación.
                </p>
                <DataTable :value="ledger.movements" :scrollable="true" scrollHeight="360px"
                           class="ledger-table" :rowClass="ledgerRowClass">
                    <Column field="date" header="Fecha" style="width: 108px;"></Column>
                    <Column header="Referencia" style="width: 150px;">
                        <template #body="s">
                            <span>{{ s.data.reference }}</span>
                            <Tag v-if="s.data.isReversal" class="ml-1" severity="warning" value="reverso"/>
                            <Tag v-if="s.data.status === 'VOID'" class="ml-1" severity="danger" value="anulado"/>
                        </template>
                    </Column>
                    <Column field="concept" header="Concepto"></Column>
                    <Column header="Debe" style="width: 110px;" bodyClass="tb-num" headerClass="tb-num-h">
                        <template #body="s">{{ s.data.debit !== '0.00' ? '$' + money(s.data.debit) : '—' }}</template>
                    </Column>
                    <Column header="Haber" style="width: 110px;" bodyClass="tb-num" headerClass="tb-num-h">
                        <template #body="s">{{ s.data.credit !== '0.00' ? '$' + money(s.data.credit) : '—' }}</template>
                    </Column>
                    <Column header="Saldo" style="width: 110px;" bodyClass="tb-num" headerClass="tb-num-h">
                        <template #body="s">${{ money(s.data.balance) }}</template>
                    </Column>
                </DataTable>

                <div class="ledger-footer">
                    <div class="ledger-foot-line">
                        <span>Total Debe</span><span class="ledger-foot-val">${{ money(ledger.totalDebit) }}</span>
                    </div>
                    <div class="ledger-foot-line">
                        <span>Total Haber</span><span class="ledger-foot-val">${{ money(ledger.totalCredit) }}</span>
                    </div>
                    <div class="ledger-foot-line ledger-foot-net">
                        <span>Saldo</span><span class="ledger-foot-val">${{ money(ledger.balance) }}</span>
                    </div>
                </div>
            </template>

            <div v-else class="ledger-loading">No se pudo cargar el detalle.</div>
        </Dialog>
    </div>
</template>

<script>
import httpRequest from '../../../service/httpRequest';
import { localISODate } from '../../../service/dates';

export default {
    data() {
        return {
            loading: false,
            asOfDate: new Date(),
            rows: [],
            totalDebit: '0.00',
            totalCredit: '0.00',
            balanced: true,
            mode: null,
            health: null,
            reposting: false,
            ledgerVisible: false,
            ledgerLoading: false,
            ledger: null,
        }
    },
    computed: {
        assetsClean() {
            const fa = this.health.fixedAssets;
            return !fa || (fa.costMatches && fa.accumulatedMatches);
        },
        // Un backend anterior a R13 no manda la clave: se lee como lista vacía.
        creditNotesMissing() {
            if (!this.health) return [];
            return this.health.coverage.creditNotesMissing || [];
        },
        // Ídem para los ajustes de stock (R15).
        stockAdjustmentsMissing() {
            if (!this.health) return [];
            return this.health.coverage.stockAdjustmentsMissing || [];
        },
        coverageClean() {
            if (!this.health) return true;
            return this.health.coverage.salesMissing.length === 0
                && this.health.coverage.purchasesMissing.length === 0
                && this.creditNotesMissing.length === 0
                && this.stockAdjustmentsMissing.length === 0;
        },
    },
    methods: {
        money(value) {
            return Number(value || 0).toFixed(2);
        },
        trialRowClass() {
            return 'tb-row-clickable';
        },
        ledgerRowClass(data) {
            return data.status === 'VOID' ? 'ledger-row-void' : '';
        },
        async openLedger(event) {
            const code = event.data && event.data.code;
            if (!code) return;
            this.ledger = null;
            this.ledgerVisible = true;
            this.ledgerLoading = true;
            const res = await httpRequest.getAccountingAccountLedger(code);
            this.ledgerLoading = false;
            if (res.status === 200) {
                this.ledger = res.data;
            } else {
                this.$toast.add({severity: 'warn', summary: 'Contabilidad', detail: res.error || 'No se pudo consultar el detalle de la cuenta', life: 4000});
            }
        },
        async repostMissing() {
            this.reposting = true;
            const res = await httpRequest.repostAccountingMissing();
            this.reposting = false;
            if (res.status === 200) {
                this.$toast.add({severity: 'success', summary: 'Contabilidad',
                                 detail: 'Asientos generados: ' + res.data.created, life: 5000});
                const [, rec] = await Promise.all([this.loadTrialBalance(), httpRequest.getAccountingReconciliation()]);
                if (rec.status === 200) this.health = rec.data;
            } else {
                this.$toast.add({severity: 'warn', summary: 'Contabilidad', detail: res.error || 'No se pudieron generar los asientos', life: 5000});
            }
        },
        async loadTrialBalance() {
            this.loading = true;
            const asOf = localISODate(this.asOfDate);   // fecha local, no UTC (H64)
            const tb = await httpRequest.getAccountingTrialBalance(asOf);
            this.loading = false;
            if (tb.status === 200) {
                this.rows = tb.data.rows;
                this.totalDebit = tb.data.totalDebit;
                this.totalCredit = tb.data.totalCredit;
                this.balanced = tb.data.balanced;
                this.mode = tb.data.mode;
            } else {
                this.$toast.add({severity: 'warn', summary: 'Contabilidad', detail: tb.error || 'No se pudo consultar el balance', life: 4000});
            }
        },
    },
    async mounted() {
        // La salud del módulo NO lleva fecha: la partida doble tiene que cumplirse
        // sobre todo el mayor, no sobre un recorte.
        const [, rec] = await Promise.all([
            this.loadTrialBalance(),
            httpRequest.getAccountingReconciliation(),
        ]);
        if (rec.status === 200) this.health = rec.data;
    },
}
</script>

<style scoped>
/* Números de la tabla alineados a la derecha, con cifras tabulares */
:deep(.tb-num) {
    text-align: right;
    font-variant-numeric: tabular-nums;
}
:deep(.tb-num-h) .p-column-header-content {
    justify-content: flex-end;
}

/* Resumen de totales: bloque alineado a la derecha, ordenado */
.tb-summary {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.35rem;
    margin-top: 1.25rem;
    padding-top: 0.75rem;
    border-top: 2px solid var(--surface-border, #dee2e6);
}
.tb-summary-line {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    width: 320px;
    padding: 0.25rem 0.25rem;
}
.tb-summary-line:first-child {
    border-bottom: 1px solid var(--surface-border, #e9ecef);
}
.tb-label {
    font-weight: 600;
    color: var(--text-color-secondary, #6c757d);
}
.tb-amount {
    font-weight: 700;
    font-size: 1.05rem;
    font-variant-numeric: tabular-nums;
}
.tb-summary-status {
    margin-top: 0.6rem;
    padding: 0.4rem 0.9rem;
    font-size: 0.9rem;
}

/* Pista + filas clicables del balance */
.tb-hint {
    margin: 0 0 0.6rem;
    font-size: 0.82rem;
    color: var(--text-color-secondary, #6c757d);
}
.tb-hint i {
    margin-right: 0.3rem;
}
:deep(.tb-row-clickable) {
    cursor: pointer;
}

/* Diálogo de detalle (mayor de la cuenta) */
.ledger-header {
    display: flex;
    align-items: baseline;
    gap: 0.55rem;
}
.ledger-code {
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: var(--primary-color, #10b981);
}
.ledger-name {
    font-weight: 600;
}
.ledger-desc {
    margin: 0 0 0.9rem;
    font-size: 0.85rem;
    color: var(--text-color-secondary, #6c757d);
}
.ledger-loading {
    padding: 1.5rem 0.5rem;
    text-align: center;
    color: var(--text-color-secondary, #6c757d);
}
.ledger-loading i {
    margin-right: 0.4rem;
}
:deep(.ledger-row-void) {
    opacity: 0.55;
    text-decoration: line-through;
}
.ledger-footer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
    margin-top: 1rem;
    padding-top: 0.75rem;
    border-top: 2px solid var(--surface-border, #dee2e6);
}
.ledger-foot-line {
    display: flex;
    justify-content: space-between;
    width: 260px;
    font-weight: 600;
    color: var(--text-color-secondary, #6c757d);
}
.ledger-foot-val {
    font-variant-numeric: tabular-nums;
    font-weight: 700;
    color: var(--text-color, #495057);
}
.ledger-foot-net {
    margin-top: 0.35rem;
    padding-top: 0.35rem;
    border-top: 1px solid var(--surface-border, #e9ecef);
    font-size: 1.02rem;
}
</style>
